module.exports = __webpack_public_path__ + "static/media/remove.e21d293c.svg";